const Config = {
    // baseUrl: 'http://localhost:4444/api',  // Localhost 
    baseUrl: 'https://tour-buddy-backend.vercel.app/api',  // Production 
};

export default Config;